import axios from '../base/axios';
import API_KEY from './key';

const GET_WESTERN = 'flixfrenzy/redux/GET_WESTERN';

// eslint-disable-next-line default-param-last
const westernReducer = (state = [], action) => {
  switch (action.type) {
    case GET_WESTERN:
      return action.payload;
    default:
      return state;
  }
};

export const getWestern = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=37`).then((res) => {
    dispatch({
      type: GET_WESTERN,
      payload: res.data,
    });
  });
};

export default westernReducer;
